app.service('productAvailabilityService', function(cartManager) {
	function makeReservation({
		shopCode,
		productId,
	}) {
		cartManager.addProduct({
			productId,
			shopCode,
			addedFrom: 'SHOPS_WITH_PRODUCT',
			delivery: 'SHOP'
		});
	}

	function getCityList(data) {
		const url = '/cities-with-shop.ltr';

		return $.ajax({
			url,
			data
		});
	}

	function getAllShops(data) {
		const url = '/refresh-shops-with-product.ltr';

		return $.ajax({
			url,
			data
		});
	}

	function getShop(data) {
		const url = '/shop-with-product.ltr';

		return $.ajax({
			url,
			data
		});
	}

	return {
		getCityList,
		getAllShops,
		getShop,
		makeReservation
	};
});
